export default __webpack_public_path__ + "static/media/wh_7.0938fff0.mp3";